import React from 'react';
import ReactDOMServer from 'react-dom/server';

import {
    FaMousePointer
} from 'react-icons/fa';

const iconPointer = ReactDOMServer.renderToString(<FaMousePointer />);


function EventTargetImpl() {}


Object.assign(EventTargetImpl.prototype, {

    addEventListener : function(type, listener) {
        if (this._listeners === undefined)
            this._listeners = {};

        let listeners = this._listeners;
        if (listeners[type] === undefined)
            listeners[type] = [];

        if (listeners[type].indexOf(listener) === -1)
            listeners[type] = listeners[type].concat([listener]);

        return this;
    },


    removeEventListener : function(type, listener) {
        if (this._listeners === undefined)
            return this;

        let listeners = this._listeners;
        if (listeners[type] === undefined )
            return this;

        let index = listeners[type].indexOf(listener);
        if (index !== -1)
            listeners[type].splice(index, 1);

        return this;
    },


    dispatchEvent : function(event) {
        if (this._listeners === undefined)
            return this;

        let listeners = this._listeners;
        let listenerArray = listeners[event.type];

        if (listenerArray !== undefined) {
            //event.target = this;
            for (let i = 0, l = listenerArray.length; i < l; i ++ ) {
                listenerArray[i].call(this, event);
            }
        }
        return this;
    }
});


class PaletteTool
{
    static POINTER_TOOL_ID = 'pointer';
    static POINTER_ICON = iconPointer;
    static POINTER_TOOL = new PaletteTool({id:PaletteTool.POINTER_TOOL_ID, icon:PaletteTool.POINTER_ICON});

    constructor(options = { id:'', icon:'', hint:'' }) {
        const { id, icon, hint} = options || { id:'', icon:'', hint:'' };

        this._id = id || '';
        this._icon = icon || '';
        this._hint = hint || '';
    }

    get id() { return this._id; }
    set id(value) { this._id = value; }

    get icon() { return this._icon; }
    set icon(value) { this._icon = value; }

    get hint() { return this._hint; }
    set hint(value) { this._hint = value; }
}


class PlanViewTool extends EventTarget {

    static EVENT_ACTIVETOOLCHANGED = 'activeToolChanged';

    constructor(options = {}) {
        super();

        Object.assign(this, EventTargetImpl.prototype);

        this._activeToolId = PaletteTool.POINTER_TOOL_ID;
    }

    get id() { throw "You should override me!"; return ""; }

    environment(options) {
        return {
            drawsViewpoints:false,
            hasCustomPalette:false,
            palette:[]
        };
    }
    activate(options) { throw "You should override 'activate'!"; }
    deactivate(options) { throw "You should override 'deactivate'!"; }

    get activeToolId() { return this._activeToolId; }
    set activeToolId(toolId) {
        this._activeToolId = toolId;
        this.dispatchEvent(new Event(PlanViewTool.EVENT_ACTIVETOOLCHANGED));
    }
}


class PlanViewJigTool extends PlanViewTool {

    static GRIP_SIZE = 6;

    constructor(options = {}) {
        super(options);
    }

    mouseMove(options) { throw "You should override 'mouseMove'!"; }
    mouseclick(options) { throw "You should override 'mouseclick'!"; }
    keydown(options) { throw "You should override 'keydown'!"; }
    draw(options) { throw "You should override 'draw'!"; }
}

export {
    PlanViewTool,
    PlanViewJigTool,
    PaletteTool
};